import React from 'react'


const DesktopButton = ( {isOpen, setIsOpen, logo, name }) => {
  return (
    <button className='desktopIcon' onClick={()=>{ isOpen === false ? setIsOpen(true) : setIsOpen(true)}}><img src={logo} alt={name}/><p>{name}</p></button>
  )
}

export default DesktopButton